'use client'

import { useState } from 'react'
import { Button } from '@vinted/web-ui'

import { SELLING_RESTRICTION_URL } from '@marketplace-web/user-restrictions/user-restrictions-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import {
  OppositeUser,
  reserveTransactionItems,
  TransactionModel,
} from '@marketplace-web/messaging/conversation-messaging-data'

import ConfirmModal from '../../../../ConfirmModal'

type Props = {
  transaction?: TransactionModel | null
  oppositeUser?: OppositeUser | null
  isSellingRestricted?: boolean
}

const Reserve = ({ transaction, oppositeUser, isSellingRestricted = false }: Props) => {
  const translate = useTranslate('conversation.hero_message')

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleReserveClick = () => setIsModalVisible(true)

  const handleReserveModalConfirmClick = async () => {
    if (!transaction || !oppositeUser || isLoading) return

    setIsLoading(true)

    await reserveTransactionItems(transaction.id, true)

    setIsLoading(false)

    setIsModalVisible(false)
  }

  const handleReserveModalCancelClick = () => {
    setIsModalVisible(false)
  }

  const renderReserveModal = () => {
    return (
      <ConfirmModal
        show={isModalVisible}
        theme="primary"
        translationsPrefix="conversation.conversation_info.reserve_modal"
        onConfirm={handleReserveModalConfirmClick}
        onCancel={handleReserveModalCancelClick}
      />
    )
  }

  const renderReserveButton = () => {
    if (!transaction) return null

    return (
      <Button
        text={translate('transaction_actions.reserve')}
        size={Button.Size.Medium}
        onClick={isSellingRestricted ? undefined : handleReserveClick}
        url={isSellingRestricted ? SELLING_RESTRICTION_URL : undefined}
        testId="reserve-button"
      />
    )
  }

  return (
    <>
      {renderReserveButton()}
      {renderReserveModal()}
    </>
  )
}

export default Reserve
